import React from 'react'
import styled from "styled-components";

const Icon = ({ id, stroke = "var(--icon-color)", strokeW = "1.5", size = "3.5rem", mSize = "7vw", pad = ".2rem", children, handleClick, mobileText = "" }) => {


    return (
        <IconWrap id={id} $stroke={stroke} $strokeW={strokeW} onClick={handleClick} $size={size} $mSize={mSize} $pad={pad}>{children}</IconWrap>
    )
}

export default Icon


const IconWrap = styled.div`  


    & svg {
        height: ${(props) => (props.$mSize)};
        width: ${(props) => (props.$mSize)};
        cursor: pointer;
        transition: opacity 3s;
        stroke-width: ${(props) => (props.$strokeW)};

        & path {
            stroke: ${(props) => (props.$stroke)};
            
        }
        
        @media (width > 800px) { 
            height: ${(props) => (props.$size)};
            width: ${(props) => (props.$size)};
            padding: ${(props) => (props.$pad)};
        }
    }

    &:hover svg {
        opacity: 0.75;

            
    }
`
